import { RootState } from '@/shared/types/state';

export const focusIndexSelector = (state: RootState) => state.macros.focusIndex;

export const filteredOptionsSelector = (state: RootState) => state.macros.options;
